
import Vue from "vue";

export default Vue.extend({
  name: "landscape-alert",
  computed: {
    showLandscapeNotif(): boolean {
      return this.$store.state.ui.deviceOrientation.orientation === "landscape";
    },
  },
  methods: {
    startToCheckDeviceOrientation() {
      const size = this.getScreenSize() as { width: number; height: number };
      const orientation = {
        orientation:
          this.getDeviceOrientation() === 90 || this.getDeviceOrientation() === -90 ? "landscape" : "portraits",
        width: size.width,
        height: size.height,
      };
      this.$store.commit("ui/setDeviceOrientation", orientation);
    },
    getDeviceOrientation(): number {
      return window?.orientation
        ? Number(window.orientation)
        : screen?.orientation?.angle
        ? screen.orientation.angle
        : 0;
    },
    getScreenSize(): { width: number; height: number } {
      // three ways getting size in different mobile devices
      // are sometimes different...
      // to unify values for width and height
      // in iOS 12.x the values are reversed
      return {
        width: Math.min(screen.availWidth, screen.availHeight),
        height: Math.max(screen.availWidth, screen.availHeight),
      };
    },
  },
  mounted() {
    this.startToCheckDeviceOrientation();
    (<any>window).addEventListener("orientationchange", this.startToCheckDeviceOrientation, { passive: true });
  },
  beforeDestroy() {
    (<any>window).removeEventListener("orientationchange", this.startToCheckDeviceOrientation, { passive: true });
  },
});
